import { makeAutoObservable, runInAction } from 'mobx';
import { filterBySearch } from '../utils/search';

const API_URL = 'https://bitrixapi.tmg-din-reestr.ru'; // URL FastAPI

class EquipmentStore {
  equipments = [];
  loading = false;
  user = null;
  auth = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Устанавливаем данные для хедеров
  setUser(user) {
    this.user = user;
  }

  setAuth(auth) {
    this.auth = auth;
  }

  setEquipments(data) {
    this.equipments = data;
  }

  // Геттер для заголовков
  get headers() {
    return {
      'X-Bitrix-User': this.user,
      'X-Bitrix-Auth': this.auth,
      'Content-Type': 'application/json'
    };
  }

  getEquipmentById(id) {
    return this.equipments.find((equip) => Number(equip.id) === Number(id));
  }

  updateEquipmentLocal(id, data) {
    const index = this.equipments.findIndex((equip) => equip.id === id);
    if (index !== -1) {
      this.equipments[index] = { ...this.equipments[index], ...data };
    }
  }

  addEquipmentLocal(data) {
    const newEquipment = { id: Date.now(), ...data };
    this.equipments.push(newEquipment);
  }

  deleteEquipmentLocal(id) {
    this.equipments = this.equipments.filter((equip) => equip.id !== id);
  }

  // Получить все оборудования
  async fetchEquipments(searchText = '') {
    this.loading = true;
    try {
      let url = `${API_URL}/equipments`;
      if (searchText) {
        url += `?search=${encodeURIComponent(searchText)}`;
      }
      const res = await fetch(url, { headers: this.headers });
      if (!res.ok) throw new Error(`HTTP error ${res.status}`);
      const data = await res.json();
      runInAction(() => {
        this.equipments = data;
      });
    } catch (e) {
      console.error('Error fetching equipments:', e);
    } finally {
      runInAction(() => (this.loading = false));
    }
  }

  // Добавить оборудование
  async addEquipment(data) {
    this.loading = true;
    try {
      const res = await fetch(`${API_URL}/equipments`, {
        method: 'POST',
        headers: this.headers,
        body: JSON.stringify(data)
      });
      if (!res.ok) throw new Error(`HTTP error ${res.status}`);
      const newEquip = await res.json();
      runInAction(() => {
        this.equipments.push(newEquip);
      });
    } catch (e) {
      console.error('Error adding equipment:', e);
    } finally {
      runInAction(() => (this.loading = false));
    }
  }

  // Обновить оборудование
  async updateEquipment(id, data) {
    this.loading = true;
    try {
      const res = await fetch(`${API_URL}/equipments/${id}`, {
        method: 'PUT',
        headers: this.headers,
        body: JSON.stringify(data)
      });
      if (!res.ok) throw new Error(`HTTP error ${res.status}`);
      const updated = await res.json();
      runInAction(() => {
        this.updateEquipmentLocal(id, updated);
      });
    } catch (e) {
      console.error('Error updating equipment:', e);
    } finally {
      runInAction(() => (this.loading = false));
    }
  }

  // Удалить оборудование
  async deleteEquipment(id) {
    this.loading = true;
    try {
      const res = await fetch(`${API_URL}/equipments/${id}`, {
        method: 'DELETE',
        headers: this.headers
      });
      if (!res.ok) throw new Error(`HTTP error ${res.status}`);
      runInAction(() => {
        this.deleteEquipmentLocal(id);
      });
    } catch (e) {
      console.error('Error deleting equipment:', e);
    } finally {
      runInAction(() => (this.loading = false));
    }
  }

  // Фильтрация на фронте
  filterEquipments(searchText) {
    if (!searchText) return this.equipments;
    const getFields = (item) => [item.name, item.type];
    return filterBySearch(this.equipments, searchText, getFields);
  }
}

const equipmentStore = new EquipmentStore();
export default equipmentStore;
